import React from 'react';

const LoadingScreen = ({ message = 'Loading...' }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: '#0B0B10',
    color: '#FFFFFF'
  }}>
    <h2>{message}</h2>
  </div>
);

export default LoadingScreen;
